import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { IntlProvider } from 'react-intl';

import { ScrollToTop } from './components';
import NotFound from './pods/pages/NotFound';

import { translations } from './translations/translations';

import * as serviceWorker from './serviceWorker';
import configureStore, { getInitialState } from './store/configure.store';
import theme from './styles/theme';
import config from './config';
import Routes from './enums/routes';

import 'react-toastify/dist/ReactToastify.css';
import 'font-awesome/css/font-awesome.min.css';
// import main app styles
import './styles/styles.css';
import AppLayout from './layouts/app-layout';
import LoggedInLayout from './layouts/logged-in';

const store = configureStore(getInitialState());

ReactDOM.render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <IntlProvider
                locale={config.DEFAULT_LANGUNAGE}
                messages={
                    // eslint-disable-next-line
                    // @ts-ignore
                    translations[config.DEFAULT_LANGUNAGE]
                }
            >
                <BrowserRouter>
                    <ScrollToTop />
                    <ToastContainer />
                    <Switch>
                        <Route exact path={Routes.ROOT} component={AppLayout} />
                        <Route exact path={Routes.TERMS_AND_CONDITIONS} component={AppLayout} />
                        <Route exact path={Routes.TERMS_PORTAL} component={AppLayout} />
                        <Route exact path={Routes.PRIVACY_POLICY} component={AppLayout} />
                        <Route exact path={Routes.ONBOARDING} component={LoggedInLayout} />
                        <Route exact path={Routes.SESSIONS} component={LoggedInLayout} />
                        <Route exact path={Routes.SESSION_DETAILS_ID} component={LoggedInLayout} />
                        <Route exact path={Routes.RESULTS_SUMMARY} component={LoggedInLayout} />
                        <Route exact path={Routes.CUSTOM_SUPPLEMENTS} component={LoggedInLayout} />
                        <Route exact path={Routes.CUSTOM_SUPPLEMENTS_DETAILS_ID} component={LoggedInLayout} />
                        <Route exact path={Routes.QUESTIONNAIRE_DETAILS_ID} component={LoggedInLayout} />
                        <Route exact path={Routes.RESULT_ID} component={LoggedInLayout} />
                        <Route exact path={Routes.JOURNALS} component={LoggedInLayout} />
                        <Route exact path={Routes.JOURNAL_EDIT} component={LoggedInLayout} />
                        <Route exact path={Routes.JOURNAL_WRITE} component={LoggedInLayout} />
                        <Route exact path={Routes.SETTINGS} component={LoggedInLayout} />
                        <Route exact path={Routes.KITS} component={LoggedInLayout} />
                        <Route exact path={Routes.SUMMARY} component={LoggedInLayout} />
                        <Route exact path={Routes.COURSE} component={LoggedInLayout} />
                        <Route exact path={Routes.DISCOUNT_CODES} component={LoggedInLayout} />
                        <Route exact path={Routes.WAREHOUSING} component={LoggedInLayout} />

                        <Route exact path={Routes.SESSION_OVERVIEW} component={LoggedInLayout} />
                        <Route exact path={Routes.SESSION_QUESTIONNAIRES} component={LoggedInLayout} />
                        <Route exact path={Routes.SESSION_QUESTIONNAIRES_ID} component={LoggedInLayout} />
                        <Route exact path={Routes.SESSION_RESULTS} component={LoggedInLayout} />
                        <Route exact path={Routes.SESSION_RESULT_ID} component={LoggedInLayout} />
                        <Route exact path={Routes.SESSION_JOURNAL} component={LoggedInLayout} />
                        <Route exact path={Routes.TRANSACTIONS} component={LoggedInLayout} />
                        <Route exact path={Routes.REPORTS} component={LoggedInLayout} />
                        <Route exact path={Routes.ASK_AI} component={LoggedInLayout} />

                        <Route path={'*'} component={NotFound} />
                    </Switch>
                </BrowserRouter>
            </IntlProvider>
        </ThemeProvider>
    </Provider>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
